export const MODULE_ID = 'organizationAdmin';
export const ORGANIZATION_MEMBERSHIP_DROPDOWN = `${MODULE_ID}/organizationMembershipDropdown`;
export const APPROVE_MEMBERSHIP_MODAL = `${MODULE_ID}/approveMembershipModal`;
export const REJECT_MEMBERSHIP_MODAL = `${MODULE_ID}/rejectMembershipModal`;
export const DELETE_MEMBERSHIP_MODAL = `${MODULE_ID}/deleteMembershipModal`;
export const CREATE_INVITATION_MODAL = `${MODULE_ID}/createInvitationModal`;
export const CANCEL_INVITATION_MODAL = `${MODULE_ID}/cancelInvitationModal`;
export const RESEND_INVITATION_MODAL = `${MODULE_ID}/resendInvitationModal`;
export const GRANT_ADMIN_MODAL = `${MODULE_ID}/grantAdminModal`;
export const REVOKE_ADMIN_MODAL = `${MODULE_ID}/revokeAdminModal`;
export const CREATE_INVITATION_FORM = `${MODULE_ID}.createInvitationForm`;
